import { Icon, SvgIconsMap } from '@toggle/design-system';
import { Citation, formatTicker } from '@toggle/toggle';
import { format } from 'date-fns';
import React, { FC } from 'react';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { useEntity } from '~/hooks/use-entities';

import * as S from './DocumentSource.styles';

export interface DocumentSourceProps {
  citation: Citation;
  isSelected: boolean;
  onClick: (citation: Citation) => void;
}

export const DocumentSource: FC<DocumentSourceProps> = ({
  citation,
  onClick,
  isSelected,
}) => {
  const formattedDate = format(new Date(citation.published_date), "yyyy 'Q'Q");

  const { data = [] } = useEntity(citation.entity);
  const entity = data[0];
  const provider = citation.document_kind;
  const formattedProvider = `${provider[0].toUpperCase()}${provider.slice(1)}`;
  const providerString = `${formattedProvider} | ${formattedDate}`;
  const percentage = `${Math.round(citation.score * 100)}%`;

  return (
    <S.Item onClick={() => onClick(citation)} aria-selected={isSelected}>
      <p>{citation.text}</p>
      <S.DetailsContainer>
        {entity && (
          <>
            <S.EntityDetails>
              <AssetLogoContainer size={12} entity={entity} />
              <span>{formatTicker(entity)}</span>
            </S.EntityDetails>
            <span>{' · '}</span>
          </>
        )}
        <Icon
          iconName={formattedProvider as keyof typeof SvgIconsMap}
          size={16}
        />
        <span>{providerString}</span>
        <S.ScoreContainer>
          <Icon iconName="Relevance" size={12} viewBox="0 0 12 12" />
          {percentage}
        </S.ScoreContainer>
      </S.DetailsContainer>
    </S.Item>
  );
};
